import React from "react";
import { observer } from "mobx-react-lite";

import "./FileInput.scss";
import useThemeService from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

interface FileInputProps {
  accept: string;
  labelKey: string;
  classname?: string;
  onChange: (files: FileList | null) => void;
}

export default observer(function FileInput(props: FileInputProps) {
  const { themeClass } = useThemeService();

  const onInputClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const element = event.target as HTMLInputElement;
    element.value = "";
  };

  return (
    <div className="file-input-container">
      <input
        type="file"
        name="file"
        id="add-file"
        className={themeClass(["file-input"])}
        accept={props.accept}
        onChange={(e) => props.onChange(e.target.files)}
        onClick={onInputClick}
      />
      <label htmlFor="add-file" className={themeClass(["button btn-small"])}>
        {translationService.translate(props.labelKey)}
      </label>
    </div>
  );
});
